import {
  BMComponentsType,
  BMPrimitives,
  BMText,
  useBMTheme,
} from "@traveloka/district-bloom";
import IcSystemCrossClose from "@traveloka/icon-kit-web/react/IcSystemCrossClose";
import { Pressable, StyleSheet } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import BMView from "../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";
import { formatMessage } from "../../../../utils";
import { TravelerPickerProps } from "./TravelerPicker";

export default function TravelerPickerHeader({
  type,
  onClose,
}: TravelerPickerProps) {
  const { CorporateTravelerPicker: cr } = useMobileContentResource();
  const insets = useSafeAreaInsets();

  const { BMComponents } = useBMTheme();
  const styles = createStyles(BMComponents);

  return (
    <BMView
      style={[
        styles.header,
        { paddingTop: BMPrimitives.BMSize.md + insets.top },
      ]}
      row
      justify="between"
      align="center"
    >
      <BMText variant="titleSmall">{formatMessage(cr.title, { type })}</BMText>
      <Pressable onPress={onClose} testID="traveler_picker-close">
        <IcSystemCrossClose
          width={24}
          height={24}
          color={BMComponents.BMStyleIconInkPrimary}
        />
      </Pressable>
    </BMView>
  );
}

function createStyles(BMComponents: BMComponentsType) {
  return StyleSheet.create({
    header: {
      padding: BMPrimitives.BMSize.md,
      backgroundColor: BMComponents.BMStyleSurfaceBgcolor,
      borderBottomColor: BMComponents.BMStyleLineBordercolorSubtle,
      borderBottomWidth: BMPrimitives.BMBorder.width.thick,
    },
  });
}
